module.exports = __webpack_public_path__ + "static/charlene-aa1193edb86497258ebc8302db569e4d.jpg";